import { ApiKeyModel } from '@core/models/api-key/api-key.model';
import { PasskeyModel } from '@core/models/profile/profile-security.model';

export interface ProfileState {
  apiKeys: ApiKeyModel[];
  apiKeysLoading: boolean;
  apiKeysError: string | null;
  cursorNextPage: number | null;
  cursorPrevPage: number | null;
  selectedApiKey: ApiKeyModel | null;
  selectedApiKeyLoading: boolean;
  selectedApiKeyError: string | null;
  createdApiKeyValue: string | null;
  apiKeyFormSaving: boolean;
  apiKeyFormError: string | null;
  apiKeyFormSuccess: boolean;
  passwordChanging: boolean;
  passwordChangeError: string | null;
  passwordChangeSuccess: boolean;
  totpStatus: boolean | null;
  totpStatusLoading: boolean;
  totpDisabling: boolean;
  totpError: string | null;
  passkeys: PasskeyModel[];
  passkeysLoading: boolean;
  passkeysError: string | null;
  passkeyDeleting: string | null;
  profileNameSaving: boolean;
  profileNameSaveError: string | null;
  profileNameSaveSuccess: boolean;
}

export const initialProfileState: ProfileState = {
  apiKeys: [],
  apiKeysLoading: false,
  apiKeysError: null,
  cursorNextPage: null,
  cursorPrevPage: null,
  selectedApiKey: null,
  selectedApiKeyLoading: false,
  selectedApiKeyError: null,
  createdApiKeyValue: null,
  apiKeyFormSaving: false,
  apiKeyFormError: null,
  apiKeyFormSuccess: false,
  passwordChanging: false,
  passwordChangeError: null,
  passwordChangeSuccess: false,
  totpStatus: null,
  totpStatusLoading: false,
  totpDisabling: false,
  totpError: null,
  passkeys: [],
  passkeysLoading: true,
  passkeysError: null,
  passkeyDeleting: null,
  profileNameSaving: false,
  profileNameSaveError: null,
  profileNameSaveSuccess: false
};
